import type { CreateTweetBodyJsonDataPollOptionsItem } from './createTweetBodyJsonDataPollOptionsItem';

/**
 * 트윗에 포함될 투표 정보 (선택 사항)
 */
export type CreateTweetBodyJsonDataPoll = {
  /**
   * 투표 기간 (분 단위, 예 5분 ~ 7일)
   * @minimum 5
   * @maximum 10080
   */
  durationMinutes: number;
  /**
   * 투표 선택지 목록 (최소 2개, 최대 4개)
   * @minItems 2
   * @maxItems 4
   */
  options: CreateTweetBodyJsonDataPollOptionsItem[];
};
